// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__Wf5fB","left":"Mid_left__g8odR","right":"Mid_right__MN38g","rightLine":"Mid_rightLine__-CpHP"};